import { Controller } from "react-hook-form";

import { TextEditor } from "../../Inputs";
import { InputTextEditorProps } from "./InputTextEditor.types";
import { useDisabledField } from "../HookForm/HookForm.context";

export function InputTextEditor({
  disabled,
  form,
  name,
  rule,
  ...props
}: InputTextEditorProps) {

  const isDisabled = useDisabledField(name);
  const isFieldDisabled = isDisabled || disabled;

  return (
    <Controller
      control={form.control}
      rules={rule}
      name={name}
      render={({ field, fieldState }) => {

        const error = fieldState.error;
        const errorMessage = error?.type === 'required' && rule?.required === true
          ? 'Field cannot be empty'
          : error?.message?.toString();

        return (
          <TextEditor
            {...props}
            helperText={!error ? props.helperText : errorMessage}
            placeholder={props.placeholder}
            onChange={(_) => {
              if (isFieldDisabled) return;
              field.onChange(_);
            }}
            required={!!rule?.required}
            disabled={isFieldDisabled}
            value={field.value}
            error={!!error}
            onInit={(_, ref) => {
              field.ref(ref);
            }}
          />
        );
      }}
    />
  );
}
